export class TagsResult {
    public textNoTags: string;
    public text: string;
    public tags: string[] = [];
    public tagsDict: { [tagName: string]: boolean } = {};
    public userName?: string;
}
